<template>
  <v-container
    fluid
    pa-8>
    <v-row
      align="center"
      justify="center">
      <v-col
        cols=12
        md=auto
        class="font-weight-bold">
        希望曜日:
      </v-col>
      <v-col
        cols="12"
        md="10"
        sm="12">
        <v-row justify="space-between">
          <v-checkbox v-model="availableDays" value="月" label="月"></v-checkbox>
          <v-checkbox v-model="availableDays" value="火" label="火"></v-checkbox>
          <v-checkbox v-model="availableDays" value="水" label="水"></v-checkbox>
          <v-checkbox v-model="availableDays" value="木" label="木"></v-checkbox>
          <v-checkbox v-model="availableDays" value="金" label="金"></v-checkbox>
          <v-checkbox v-model="availableDays" value="土" label="土"></v-checkbox>
          <v-checkbox v-model="availableDays" value="日" label="日"></v-checkbox>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center">
      <v-col
        cols=12
        md=auto
        class="font-weight-bold subheading">
        希望地域：
      </v-col>
      <v-col
        cols="12"
        md="10"
        sm="12">
        <v-select
          v-model="prefecture"
          :items="prefectures"
          label="都道府県">
        </v-select>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center">
      <v-col
        cols=12
        sm=12
        md=auto
        class="font-weight-bold">
        希望生徒:
      </v-col>
      <v-col
        cols=auto
        md=10
        sm=12
        >
        <v-row
          justify="space-between">
          <v-checkbox v-model="schools" value="elementary_school" :label="`小学生`"></v-checkbox>
          <v-checkbox v-model="schools" value="junior_high_school" :label="`中学生`"></v-checkbox>
          <v-checkbox v-model="schools" value="high_school" :label="`高校生`"></v-checkbox>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-btn
        depressed
        rounded
        color="primary"
        @click="target">
        <span class="font-weight-bold">絞り込む</span>
      </v-btn>
    </v-row>
  </v-container>
</template>


<script>
import { prefectures } from "@/models/Regions.js"

export default {
  name:"StudentsSearchBox",
  props: {
    value: Object
  },
  data() {
    return {
      prefectures: prefectures,
    }
  },
  methods: {
    target() {
      this.$emit("target")
    },
    updateValue(diff) {
      this.$emit("input", { ...this.value, ...diff })
    }
  },
  computed: {
    schools: {
      get() {
        return this.value.schools
      },
      set(schools) {
        this.updateValue({ schools })
      }
    },
    prefecture: {
      get() {
        return this.value.prefecture
      },
      set(prefecture) {
        this.updateValue({ prefecture })
      }
    },
    availableDays: {
      get() {
        return this.value.availableDays
      },
      set(availableDays) {
        this.updateValue({ availableDays })
      }
    },
  }
}
</script>
